import { render } from "./KryptonIcon.vue?vue&type=template&id=3049daa6&lang=pug"
import script from "./KryptonIcon.vue?vue&type=script&lang=js"
export * from "./KryptonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__